module.exports = __webpack_public_path__ + "img/logo.435ef4e8.svg";